import React from "react";

import {
  Stack,
  Text,
  Box,
  Divider,
  SimpleGrid,
  Image,
} from "@chakra-ui/react";

import { formatDate } from "utils/dateFormatter";

import StatusBadge, {
  getStatusVariant,
} from "../../../../components/Badges/StatusBadge";


const ViewStarterKitPurchase = ({
  purchase,
}) => {

  if (!purchase) {
    return (
      <Text color="gray.500">
        No purchase information available.
      </Text>
    );
  }


  const agentName = (() => {

    const firstName =
      purchase.agent?.user?.first_name ||
      "";

    const lastName =
      purchase.agent?.user?.last_name ||
      "";

    return (
      `${firstName} ${lastName}`.trim() ||
      purchase.agent?.user?.username ||
      "N/A"
    );

  })();


  return (

    <Stack spacing={5}>

      {/* PURCHASE NUMBER + DATE */}

      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={5}
      >

        <Box>

          <Text
            fontSize="sm"
            color="gray.500"
            mb={1}
          >
            Purchase Number
          </Text>

          <Text fontWeight="400">
            {purchase.purchase_number || "N/A"}
          </Text>

        </Box>


        <Box>

          <Text
            fontSize="sm"
            color="gray.500"
            mb={1}
          >
            Date Created
          </Text>

          <Text fontWeight="400">
            {purchase.created_at
              ? formatDate(
                  purchase.created_at
                )
              : "N/A"}
          </Text>

        </Box>

      </SimpleGrid>


      <Divider />


      {/* PURCHASE STATUS + AMOUNTS */}

      <SimpleGrid
        columns={{ base: 1, md: 3 }}
        spacing={5}
      >

        <Box>

          <Text
            fontSize="sm"
            color="gray.500"
            mb={2}
          >
            Purchase Status
          </Text>

          <StatusBadge
            label={
              purchase.purchase_status ||
              "N/A"
            }
            variant={
              getStatusVariant(
                purchase.purchase_status
              )
            }
          />

        </Box>


        <Box>

          <Text
            fontSize="sm"
            color="gray.500"
            mb={1}
          >
            Subtotal
          </Text>

          <Text fontWeight="400">
            P{" "}
            {Number(
              purchase.subtotal || 0
            ).toLocaleString()}
          </Text>

        </Box>


        <Box>

          <Text
            fontSize="sm"
            color="gray.500"
            mb={1}
          >
            Total Amount
          </Text>

          <Text fontWeight="400">
            P{" "}
            {Number(
              purchase.total_amount || 0
            ).toLocaleString()}
          </Text>

        </Box>

      </SimpleGrid>


      <Divider />


      {/* AGENT DETAILS */}

      <Box
        borderWidth="1px"
        borderRadius="lg"
        p={5}
        bg="gray.50"
      >

        <Text
          fontSize="md"
          fontWeight="600"
          color="#8D93A1"
          mb={5}
        >
          Agent Details
        </Text>


        <SimpleGrid
          columns={{
            base: 1,
            md: 3,
          }}
          spacing={5}
        >

          <Box>

            <Text
              fontSize="sm"
              color="gray.500"
              mb={1}
            >
              Agent
            </Text>

            <Text fontWeight="400">
              {agentName}
            </Text>

          </Box>


          <Box>

            <Text
              fontSize="sm"
              color="gray.500"
              mb={1}
            >
              Agent Number
            </Text>

            <Text fontWeight="400">
              {purchase.agent?.agent_number ||
                "N/A"}
            </Text>

          </Box>


          <Box>

            <Text
              fontSize="sm"
              color="gray.500"
              mb={1}
            >
              Operating Area
            </Text>

            <Text fontWeight="400">
              {purchase.agent?.operating_area ||
                "N/A"}
            </Text>

          </Box>

        </SimpleGrid>

      </Box>


      <Divider />


      {/* PURCHASED COMPONENTS */}

      <Box>

        <Text
          fontWeight="600"
          mb={4}
          color="#8D93A1"
        >
          Purchased Components
        </Text>


        {Array.isArray(
          purchase.items
        ) &&
        purchase.items.length > 0 ? (

          <Stack spacing={4}>

            {purchase.items.map(
              (item) => {

                const component =
                  item.starter_kit_component;

                const image =
                  component?.component_images?.[0];

                const BASE_URL =
                  process.env
                    .REACT_APP_API_BASE_URL;


                const imageUrl =
                  image && BASE_URL
                    ? `${BASE_URL.replace(
                        /\/$/,
                        ""
                      )}/${String(
                        image
                      ).replace(
                        /^\//,
                        ""
                      )}`
                    : null;


                return (

                  <Box
                    key={
                      item.starter_kit_purchase_item_id
                    }
                    borderWidth="1px"
                    borderRadius="md"
                    p={3}
                  >

                    <Stack
                      direction="row"
                      spacing={4}
                      alignItems="center"
                    >

                      {imageUrl ? (

                        <Image
                          src={imageUrl}
                          alt={
                            component?.component_name ||
                            "Component"
                          }
                          boxSize="60px"
                          objectFit="contain"
                          borderRadius="md"
                        />

                      ) : null}


                      <Box>

                        <Text
                          fontWeight="400"
                        >
                          {
                            component?.component_name ||
                            "N/A"
                          }
                        </Text>


                        <Text
                          fontSize="sm"
                          color="gray.500"
                        >
                          Quantity:{" "}
                          {item.quantity || 0}
                        </Text>


                        <Text
                          fontSize="sm"
                          color="gray.500"
                        >
                          Unit Price: P{" "}
                          {Number(
                            item.unit_price || 0
                          ).toLocaleString()}
                        </Text>


                        <Text
                          fontSize="sm"
                          fontWeight="400"
                        >
                          Total: P{" "}
                          {Number(
                            item.line_total || 0
                          ).toLocaleString()}
                        </Text>

                      </Box>

                    </Stack>

                  </Box>

                );

              }
            )}

          </Stack>

        ) : (

          <Text
            color="gray.500"
            fontSize="sm"
          >
            No components found.
          </Text>

        )}

      </Box>

    </Stack>

  );
};


export default ViewStarterKitPurchase;